import customSelect from 'custom-select';
const filterSelect = customSelect('.filter-select select')[0];

const selectContainer = $('.filter-select .custom-select-container');

$(selectContainer).mouseenter(function (e) {
  e.stopPropagation();
  filterSelect.open = true;
});

$(selectContainer).mouseleave(function (e) {
  e.stopPropagation();
  filterSelect.open = false;
});
